export const COUNTRIES = [
  { name: "France", flag: "🇫🇷", code: "FR" },
  { name: "États-Unis", flag: "🇺🇸", code: "US" },
  { name: "Royaume-Uni", flag: "🇬🇧", code: "GB" },
  { name: "Allemagne", flag: "🇩🇪", code: "DE" },
  { name: "Espagne", flag: "🇪🇸", code: "ES" },
  { name: "Italie", flag: "🇮🇹", code: "IT" },
  { name: "Portugal", flag: "🇵🇹", code: "PT" },
  { name: "Suisse", flag: "🇨🇭", code: "CH" },
  { name: "Belgique", flag: "🇧🇪", code: "BE" },
  { name: "Pays-Bas", flag: "🇳🇱", code: "NL" },
  { name: "Luxembourg", flag: "🇱🇺", code: "LU" },
  { name: "Irlande", flag: "🇮🇪", code: "IE" },
  { name: "Autriche", flag: "🇦🇹", code: "AT" },
  { name: "Danemark", flag: "🇩🇰", code: "DK" },
  { name: "Suède", flag: "🇸🇪", code: "SE" },
  { name: "Norvège", flag: "🇳🇴", code: "NO" },
  { name: "Finlande", flag: "🇫🇮", code: "FI" },
  { name: "Islande", flag: "🇮🇸", code: "IS" },
  { name: "Pologne", flag: "🇵🇱", code: "PL" },
  { name: "République tchèque", flag: "🇨🇿", code: "CZ" },
  { name: "Hongrie", flag: "🇭🇺", code: "HU" },
  { name: "Grèce", flag: "🇬🇷", code: "GR" },
  { name: "Croatie", flag: "🇭🇷", code: "HR" },
  { name: "Roumanie", flag: "🇷🇴", code: "RO" },
  { name: "Bulgarie", flag: "🇧🇬", code: "BG" },
  { name: "Turquie", flag: "🇹🇷", code: "TR" },
  { name: "Russie", flag: "🇷🇺", code: "RU" },
  { name: "Ukraine", flag: "🇺🇦", code: "UA" },
  { name: "Maroc", flag: "🇲🇦", code: "MA" },
  { name: "Tunisie", flag: "🇹🇳", code: "TN" },
  { name: "Algérie", flag: "🇩🇿", code: "DZ" },
  { name: "Égypte", flag: "🇪🇬", code: "EG" },
  { name: "Afrique du Sud", flag: "🇿🇦", code: "ZA" },
  { name: "Kenya", flag: "🇰🇪", code: "KE" },
  { name: "Tanzanie", flag: "🇹🇿", code: "TZ" },
  { name: "Namibie", flag: "🇳🇦", code: "NA" },
  { name: "Botswana", flag: "🇧🇼", code: "BW" },
  { name: "Sénégal", flag: "🇸🇳", code: "SN" },
  { name: "Nigéria", flag: "🇳🇬", code: "NG" },
  { name: "Maurice", flag: "🇲🇺", code: "MU" },
  { name: "Seychelles", flag: "🇸🇨", code: "SC" },
  { name: "Émirats arabes unis", flag: "🇦🇪", code: "AE" },
  { name: "Arabie saoudite", flag: "🇸🇦", code: "SA" },
  { name: "Qatar", flag: "🇶🇦", code: "QA" },
  { name: "Koweït", flag: "🇰🇼", code: "KW" },
  { name: "Bahreïn", flag: "🇧🇭", code: "BH" },
  { name: "Oman", flag: "🇴🇲", code: "OM" },
  { name: "Jordanie", flag: "🇯🇴", code: "JO" },
  { name: "Liban", flag: "🇱🇧", code: "LB" },
  { name: "Israël", flag: "🇮🇱", code: "IL" },
  { name: "Inde", flag: "🇮🇳", code: "IN" },
  { name: "Chine", flag: "🇨🇳", code: "CN" },
  { name: "Japon", flag: "🇯🇵", code: "JP" },
  { name: "Corée du Sud", flag: "🇰🇷", code: "KR" },
  { name: "Singapour", flag: "🇸🇬", code: "SG" },
  { name: "Malaisie", flag: "🇲🇾", code: "MY" },
  { name: "Thaïlande", flag: "🇹🇭", code: "TH" },
  { name: "Indonésie", flag: "🇮🇩", code: "ID" },
  { name: "Vietnam", flag: "🇻🇳", code: "VN" },
  { name: "Philippines", flag: "🇵🇭", code: "PH" },
  { name: "Hong Kong", flag: "🇭🇰", code: "HK" },
  { name: "Taïwan", flag: "🇹🇼", code: "TW" },
  { name: "Sri Lanka", flag: "🇱🇰", code: "LK" },
  { name: "Maldives", flag: "🇲🇻", code: "MV" },
  { name: "Népal", flag: "🇳🇵", code: "NP" },
  { name: "Australie", flag: "🇦🇺", code: "AU" },
  { name: "Nouvelle-Zélande", flag: "🇳🇿", code: "NZ" },
  { name: "Fidji", flag: "🇫🇯", code: "FJ" },
  { name: "Canada", flag: "🇨🇦", code: "CA" },
  { name: "Mexique", flag: "🇲🇽", code: "MX" },
  { name: "Brésil", flag: "🇧🇷", code: "BR" },
  { name: "Argentine", flag: "🇦🇷", code: "AR" },
  { name: "Chili", flag: "🇨🇱", code: "CL" },
  { name: "Pérou", flag: "🇵🇪", code: "PE" },
  { name: "Colombie", flag: "🇨🇴", code: "CO" },
  { name: "Équateur", flag: "🇪🇨", code: "EC" },
  { name: "Uruguay", flag: "🇺🇾", code: "UY" },
  { name: "Costa Rica", flag: "🇨🇷", code: "CR" },
  { name: "Panama", flag: "🇵🇦", code: "PA" },
  { name: "République dominicaine", flag: "🇩🇴", code: "DO" },
  { name: "Cuba", flag: "🇨🇺", code: "CU" },
  { name: "Jamaïque", flag: "🇯🇲", code: "JM" },
];
